import { render, staticRenderFns } from "./RequestStats.vue?vue&type=template&id=1c01ecc9&lang=pug&"
import script from "./RequestStats.vue?vue&type=script&lang=js&"
export * from "./RequestStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports